import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../Component/Comman/PageTitle';
import { fetchCryptoTrades } from '../../Redux/Actions/dataActions';

function CryptoPage({ cryptoTrades, fetchCryptoTrades, loading }) {
    const hasFetched = useRef(false);
    const [filters, setFilters] = useState({
        status: '',
        page: 1,
        limit: 10,
        sortBy: 'createdAt',
        sortOrder: 'desc'
    });

    useEffect(() => {
        if (!hasFetched.current && !loading) {
            hasFetched.current = true;
            fetchCryptoTrades(filters);
        }
    }, [fetchCryptoTrades, loading]);

    useEffect(() => {
        if (hasFetched.current) {
            fetchCryptoTrades(filters);
        }
    }, [filters, fetchCryptoTrades]);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
            page: name === 'page' ? parseInt(value) : 1
        }));
    };

    const handlePageChange = (newPage) => {
        setFilters(prev => ({
            ...prev,
            page: newPage
        }));
    };

    const trades = cryptoTrades?.data || [];
    const pagination = cryptoTrades?.pagination || {};
    const stats = cryptoTrades?.stats || {};

    return (
        <>
            <div className="body-header border-bottom d-flex py-3 mb-3">
                <PageTitle pagetitle='Crypto Trades' sidebutton={false} />
            </div>
            <div className="container-xxl">
                {/* Statistics Cards */}
                {stats && Object.keys(stats).length > 0 && (
                    <div className="row g-3 mb-3">
                        {stats.totalTrades !== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <div className="text-muted small text-uppercase mb-1">Total Trades</div>
                                                <h3 className="mb-0 fw-bold">{stats.totalTrades || 0}</h3>
                                            </div>
                                            <div className="text-primary" style={{ fontSize: '2.5rem' }}>
                                                <i className="icofont-chart-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {stats.totalProfit !== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <div className="text-muted small text-uppercase mb-1">Total Profit</div>
                                                <h3 className="mb-0 fw-bold text-success">${(stats.totalProfit || 0).toFixed(2)}</h3>
                                            </div>
                                            <div className="text-success" style={{ fontSize: '2.5rem' }}>
                                                <i className="icofont-arrow-up"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {stats.totalLoss !== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <div className="text-muted small text-uppercase mb-1">Total Loss</div>
                                                <h3 className="mb-0 fw-bold text-danger">${(stats.totalLoss || 0).toFixed(2)}</h3>
                                            </div>
                                            <div className="text-danger" style={{ fontSize: '2.5rem' }}>
                                                <i className="icofont-arrow-down"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {stats.profitTrades !== undefined && (
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <div className="text-muted small text-uppercase mb-1">Profit Trades</div>
                                                <h3 className="mb-0 fw-bold text-info">{stats.profitTrades || 0}</h3>
                                            </div>
                                            <div className="text-info" style={{ fontSize: '2.5rem' }}>
                                                <i className="icofont-check-circled"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Filters */}
                <div className="card mb-3">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-3">
                                <label className="form-label">Status</label>
                                <select
                                    className="form-select"
                                    name="status"
                                    value={filters.status}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">All</option>
                                    <option value="active">Active</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Sort By</label>
                                <select
                                    className="form-select"
                                    name="sortBy"
                                    value={filters.sortBy}
                                    onChange={handleFilterChange}
                                >
                                    <option value="createdAt">Created At</option>
                                    <option value="amount">Amount</option>
                                    <option value="profit">Profit</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Sort Order</label>
                                <select
                                    className="form-select"
                                    name="sortOrder"
                                    value={filters.sortOrder}
                                    onChange={handleFilterChange}
                                >
                                    <option value="desc">Descending</option>
                                    <option value="asc">Ascending</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Items Per Page</label>
                                <select
                                    className="form-select"
                                    name="limit"
                                    value={filters.limit}
                                    onChange={handleFilterChange}
                                >
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Trades Table */}
                <div className="card">
                    <div className="card-header py-3 bg-transparent border-bottom">
                        <h6 className="mb-0 fw-bold">Crypto Trades</h6>
                    </div>
                    <div className="card-body">
                        {loading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : trades.length > 0 ? (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Symbol</th>
                                                <th>Amount</th>
                                                <th>Entry Price</th>
                                                <th>Current/Exit Price</th>
                                                <th>Profit/Loss</th>
                                                <th>Status</th>
                                                <th>Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {trades.map((trade, index) => (
                                                <tr key={trade._id || trade.id || index}>
                                                    <td>{trade.symbol || 'N/A'}</td>
                                                    <td>${(trade.amount || 0).toFixed(2)}</td>
                                                    <td>${(trade.entryPrice || 0).toFixed(2)}</td>
                                                    <td>${(trade.currentPrice || trade.exitPrice || 0).toFixed(2)}</td>
                                                    <td>
                                                        <span className={trade.profit >= 0 ? 'text-success' : 'text-danger'}>
                                                            ${(trade.profit || trade.profitLoss || 0).toFixed(2)}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${
                                                            trade.status === 'active' ? 'bg-success' :
                                                            trade.status === 'completed' ? 'bg-secondary' :
                                                            'bg-warning'
                                                        }`}>
                                                            {trade.status ? trade.status.charAt(0).toUpperCase() + trade.status.slice(1) : 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {trade.createdAt 
                                                            ? new Date(trade.createdAt).toLocaleDateString()
                                                            : 'N/A'
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {pagination && pagination.pages > 1 && (
                                    <nav aria-label="Page navigation" className="mt-3">
                                        <ul className="pagination justify-content-center">
                                            <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(pagination.page - 1)}
                                                    disabled={pagination.page === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {[...Array(pagination.pages)].map((_, i) => {
                                                const pageNum = i + 1;
                                                if (
                                                    pageNum === 1 ||
                                                    pageNum === pagination.pages ||
                                                    (pageNum >= pagination.page - 2 && pageNum <= pagination.page + 2)
                                                ) {
                                                    return (
                                                        <li key={pageNum} className={`page-item ${pagination.page === pageNum ? 'active' : ''}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => handlePageChange(pageNum)}
                                                            >
                                                                {pageNum}
                                                            </button>
                                                        </li>
                                                    );
                                                } else if (pageNum === pagination.page - 3 || pageNum === pagination.page + 3) {
                                                    return (
                                                        <li key={pageNum} className="page-item disabled">
                                                            <span className="page-link">...</span>
                                                        </li>
                                                    );
                                                }
                                                return null;
                                            })}
                                            <li className={`page-item ${pagination.page === pagination.pages ? 'disabled' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(pagination.page + 1)}
                                                    disabled={pagination.page === pagination.pages}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                )}
                            </>
                        ) : (
                            <div className="text-center py-5">
                                <i className="icofont-bitcoin fs-1 text-muted mb-3 d-block"></i>
                                <p className="text-muted mb-0">No crypto trades found.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    cryptoTrades: state.data?.trades?.crypto,
    loading: state.data?.loading?.cryptoTrades || false,
});

export default connect(mapStateToProps, {
    fetchCryptoTrades
})(CryptoPage);
